import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col bg-neutral-50">
      <SEO title="Not Found" description="Page not found." path="/404" noindex />
      <Header />
      <main className="flex-1 flex items-center justify-center px-4">
        <div className="text-center">
          <div className="text-6xl font-heading font-black text-neutral-900">404</div>
          <div className="mt-2 text-neutral-600">Page not found.</div>
          <Link to="/" className="mt-4 inline-block px-4 py-2 rounded-md bg-red-600 text-white text-sm font-semibold">Go Home</Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
